import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { useT } from "~app/BundleProvider";

const NodeHeader = ({index, title, isOpen, onShowContent, onSelect}) => {
  const t = useT();
  return (
    <div className="NodeHeader"
      role="button"
      onClick={onSelect}
      tabIndex="0"
      onKeyPress={(event) => {
        if(event.key === 'Enter' || event.key === ' '){
          onSelect(event);
        }
      }}>
      <div className="NodeHeader__index">{index}</div>
      <div className="NodeHeader__title">{t(title)}</div>
      <div role="button"
        tabIndex="0"
        aria-label={t("expand-collapse")}
        onClick={onShowContent}
        onKeyPress={(event) => {
          if(event.key === 'Enter' || event.key === ' '){
            onShowContent(event);
          }
        }}
        className={classNames("NodeHeader__chevron", {"NodeHeader__chevron--open":isOpen})} ></div>
    </div>
  );
};

NodeHeader.propTypes = {
  index: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  onShowContent: PropTypes.func,
  onSelect: PropTypes.func,
};

export default NodeHeader;



// WEBPACK FOOTER //
// ./src/pages/Main/NodeList/NodeHeader.js